import VueCookies from "vue-cookies";
import axios from "axios";

class TokenStore {
    constructor() {
        this.state = {
            token: null,
        }
    }

    removeToken() {
        this.token = null;
        VueCookies.set(
            "session_cookie",
            null,
            1,
            null,
            null,
            null,
            "lax"
        );
    }

    setToken(token) {
        this.token = token;
        VueCookies.set(
            "session_cookie",
            token,
            parseInt(process.env.VUE_APP_TOKEN_SESSION_SEC),
            null,
            null,
            null,
            "lax"
        );
    }

    getToken() {
        this.token = VueCookies.get("session_cookie");
        return this.token;
    }

    refreshToken() {
        axios
        .get(
            process.env.VUE_APP_API_ADDR + "/api/auth/refresh",
            {
                headers: { Authorization: this.token }
            }
        )
        .then(res => {
            if (res.data.success) {
                this.removeToken();
                this.setToken(res.data.token);
               // console.log('refreshed');
            }
        })
        .catch(() => {
            this.removeToken();
            window.location.reload();
           
        });
    }









}

export default new TokenStore();
